var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker',_vm._g(_vm._b({attrs:{"format":_vm.format,"value":_vm.range,"first-day-of-week":1,"lang":_vm.lang,"range":""},on:{"input":_vm.input}},'date-picker',_vm.$attrs,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }